const setNativeValue = (element, value) => {
  if (!element) return;
  const descriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
  const setter = descriptor?.set;
  if (setter) {
    setter.call(element, value);
  } else {
    element.value = value;
  }
};

export const clearRsuitePickerSearchInput = (pickerHandleOrRef) => {
  const handle = pickerHandleOrRef?.current ?? pickerHandleOrRef;
  if (!handle) return;

  let container = null;
  try {
    container = handle.overlay;
  } catch {
    container = handle.root;
  }

  if (!container?.querySelector) return;

  const input = container.querySelector('input[role="searchbox"]');
  if (!input) return;

  setNativeValue(input, '');
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));

  // Keep focus in the search box for rapid entry.
  input.focus?.();
};

export const clearRsuitePickerSearchInputSoon = (pickerHandleOrRef) => {
  setTimeout(() => clearRsuitePickerSearchInput(pickerHandleOrRef), 0);
};
